import React from "react";
import { MrSelect, MrCrudView } from "mr_react_framework";
import { actions } from "./redux";
import commonSelectors from "App/commonSelectors";
import PromptsList from "./PromptsList/PromptsList";
import { SelectAIModel } from "components/AppSpecific/SelectSubject/SelectSubject";
import PromptsFilter from "./PromptsFilter/PromptsFilter";
import TextArea from "antd/lib/input/TextArea";

const returnForm = () => {
  let form = {
    schema: {
      type: "object",
      properties: {
        code: {
          type: "string",
          title: "Code",
          span: 12
        },
        label: {
          type: "string",
          title: "Label",
          span: 12
        },
        // desc: {
        //   type: "text",
        //   title: "Description",
        // },
        model: {
          type: "string",
          title: "Model",
          widget: SelectAIModel,
          span: 6
        },
        prompt_text: {
          type: "text",
          title: "Prompt text",
          widget: TextArea,
          widgetConfig: {
            rows: 10,
            // autoSize: true
          }
        },
        api_endpoint: {
          type: "string",
          title: "API endpoint",
        },
        api_params: {
          type: "string",
          title: "API params",
        },
        // status: {
        //   type: "string",
        //   title: "Status",
        // },
      },
    },
  };
  return form;
};

const Prompts = MrCrudView({
  resourceName: "prompts",
  singleResourceName: "prompt",
  // displayName: "Create/Edit feature",
  resourceUrl: "/prompts",
  // filter: BoardsFilter,
  isRoute: true,
  selectorsObj: {
    ...commonSelectors,
  },
  // listItem: BoardListItem,
  filter: PromptsFilter,
  forms: [{ 
    name: "prompts", 
    form: returnForm, 
    // config: {isModal: true, visible: true} 
  }],
  actions,
  actionNames: ["fetch", "create", "show", "update", "delete"],
  // firstTimeFetchParams: { with_users: true }
  config: {
    itemPreview: {
      widget: (props) => {
        console.log("itemDetail props", props);
        return <span>Item Detail {JSON.stringify(props.item)}</span>;
      },
    },
    itemDetail: {
      widget: (props) => {
        console.log("itemDetail props", props);
        return <span>Item Detail {JSON.stringify(props.item)}</span>;
      },
      // widget: ProgrammeItemDetail,
    },
    pagination: {
      show: true,
    },
    filter: {
      show: true,
      widget: PromptsFilter,
    },
    core: {
      setQueryParams: true,
    },
    list: {
      show: true,
      type: "table/list/custom",
      widget: PromptsList,
      // widget: (props) => {
      // return <span>List</span>;
      // },
    },
  },
});

// Plans.defaultProps = {};

Prompts.propTypes = {};
export default Prompts;
